// @flow
import React from 'react';

import { t } from 'Src/i18n';

const PROPOSAL_SEARCH_ERROR_MAPPING = {
  noAccommodation: 'noAccommodation',
  noTransport: 'noTransport',
  unavailableForBirthdates: 'ageIncorrectOrUnauthorized',
  invalidBookingCriteria: 'invalidBookingCriteria',
  noProposalWithFlight: 'noProposalWithFlight',
  noProposalAvailable: 'noProposalAvailable',
  technicalError: 'technicalError',
  unableToMakeProposal: 'unableToMakeProposal',
};

type Props = {
  errorCode: ?string,
};

export const BookingErrors = ({ errorCode }: Props) => (
  <div className="Package-error Package-noProposal Package-proposalAnchor Package-accommodationsAnchor">
    <div className="Package-errorContent">
      {errorCode && PROPOSAL_SEARCH_ERROR_MAPPING[errorCode]
        ? t(`booking.accommodation.errorMessages.${PROPOSAL_SEARCH_ERROR_MAPPING[errorCode]}`)
        : t('booking.accommodation.errorMessageNoProposal')}
    </div>
  </div>
);
